import { cx, css, useTheme } from '@fable/theme'
import { FlexBox, Text } from '@fable/components'
import ContainerRounded from '../container_rounded/ContainerRounded'
import { Toggle } from '@fable/components'
import CheckIcon from '../../assets/icons/components/CheckIcon'

const FieldToggle: React.VFC<{
  title: string | React.ReactNode | React.ReactNode[]
  description: string
  checked: boolean
  disabled?: boolean
  onToggle: () => void
}> = ({ title, description, checked, disabled, onToggle }) => {
  const { colors } = useTheme()

  return (
    <ContainerRounded
      className={css`
        background: ${colors.lightGrey};
        overflow: hidden;
      `}
    >
      <FlexBox justifyContent="space-between">
        <div
          className={css`
            margin-right: 5px;
          `}
        >
          <div>
            <Text type="body" sizing={{ base: 'S', mobileL: 'M' }}>
              {title}
            </Text>
          </div>
          <Text
            type="label"
            sizing={{ base: 'M', mobileL: 'L' }}
            color={colors.hurricane}
          >
            {description}
          </Text>
        </div>
        <Toggle
          onToggle={disabled ? () => null : onToggle}
          name="privacyToggle"
          checked={checked}
          disabled={disabled}
          onIndicator={
            <div
              className={css`
                width: 10px;
                path {
                  fill: ${colors.shamrock};
                }
              `}
            >
              <CheckIcon />
            </div>
          }
          className={cx(
            css`
              max-width: 48px;
              flex: 1 0 auto;
            `,
            disabled &&
              css`
                opacity: 0.6;
                * {
                  cursor: default;
                }
              `
          )}
        />
      </FlexBox>
    </ContainerRounded>
  )
}

export default FieldToggle
